"use client";

import React from "react";
import { APIProvider, Map } from "@vis.gl/react-google-maps";

// interfaces
import { ISearchMap } from "./ISearchMap";
import { ISingleSearch } from "@/types/api/SingleSearchResponse";

//assets
import styles from "@/assets/styles/components/search-map.module.scss";
import AdvancedMarkerComponent from "./components/AdvancedMarkerComponent";

declare global {
  interface Window {
    google: unknown;
  }
}

const DEFAULT_ZOOM = 7;

export const getMapBounds = (locations: ISingleSearch[]) => {
  const bounds = new window.google.maps.LatLngBounds();
  locations.forEach((marker) => {
    bounds.extend(new window.google.maps.LatLng(marker.latitude, marker.longitude));
  });

  return bounds;
};


const SearchMap = ({
  locations = [],
  defaultCenter,
  activeLocationId,
}: ISearchMap) => {

  return (
    <div className={styles["locl-search-map"]} data-testid="locl-google-map">
      <APIProvider apiKey={process.env.NEXT_PUBLIC_GOOGL_MAPS_API as string}>
        <Map
          zoom={DEFAULT_ZOOM}
          maxZoom={15}
          scrollwheel={true}
          center={defaultCenter}
          disableDefaultUI={true}
          mapId="google-map-search-location"
        >
          {locations.map((location, index) => (
            <AdvancedMarkerComponent
              position={{ lat: location.latitude, lng: location.longitude }}
              key={`${index}-${location.id}`}
              // it is necessary to work popover hover effect
              onClick={() => ({ })}
              location={location}
              activeLocationId={activeLocationId}
            />
          ))}
        </Map>
      </APIProvider>
    </div>
  );
};

export default SearchMap;
